import {ListStore} from "../common/list-store/entity";
import { writable, derived } from 'svelte/store'

let storedOrganizations = !sessionStorage.getItem("organizationStore")?
    [] :
    JSON.parse(sessionStorage.getItem("organizationStore"))

export const organizationStore = writable(storedOrganizations)

organizationStore.subscribe(value => {
    sessionStorage.setItem("organizationStore", JSON.stringify(value))
})

const organizationTemplate =  derived(organizationStore,
    $organizationStore => ({
    id: "",
    name: "",
    companyId : $organizationStore.length + 1,
    kvk : "",
    street : "",
    number : "",
    postCode : "",
    city : "",
    country : "NL",
    branch : ""
}))

export let currentOrganization = writable({...organizationTemplate})

export let organizationList = new ListStore(organizationTemplate, organizationStore, currentOrganization)